import axios from '@axios'
import i18n from '@/libs/i18n'
import settings from '../../../settings';
let baseUrl = settings.apiBaseUrl;

export default {
    namespaced: true,
    state: {
        calendarOptions: [{
                color: 'warning',
                label: 'workshops',
                name: {
                    tr: 'Atölyeler',
                    en: 'Workshops',
                }
            },
            {
                color: 'success',
                label: 'educations',
                name: {
                    tr: 'Eğitimler',
                    en: 'Educations',
                }
            },
            {
                color: 'info',
                label: 'other',
                name: {
                    tr: 'Diğer',
                    en: 'Other',
                }
            }
            // {
            //     color: 'warning',
            //     label: 'Family',
            // },
            // {
            //     color: 'success',
            //     label: 'Holiday',
            // },
            // {
            //     color: 'info',
            //     label: 'ETC',
            // },
        ],
        // selectedCalendars: ['Personal', 'Business', 'Family', 'Holiday', 'ETC'],
        selectedCalendars: ['workshops', 'educations', 'other'],
    },
    getters: {},
    mutations: {
        SET_SELECTED_EVENTS(state, val) {
            state.selectedCalendars = val
        },
    },
    actions: {
        fetchEvents(ctx, { calendars }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`${baseUrl}/api/v1/dashboard/events/calendar?locale=${i18n.locale}`, {
                        params: {
                            calendars: calendars.join(','),
                        },
                    })
                    .then(response => {
                        resolve(response);
                        console.log(response);
                    })
                    .catch(error => reject(error))
            })
        },
        addEvent(ctx, { event }) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/apps/calendar/events', { event })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        updateEvent(ctx, { event }) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/apps/calendar/events/${event.id}`, { event })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        removeEvent(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/apps/calendar/events/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
    },
}